import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { Select } from '../../ui-kit/Select/Select.js';
export const WrapperSelect = JSX(({ data, fieldLabel, fieldValue, selected, placeholder = '', setSelected, label }) => {
    const dataFormat = data
        .filter(Boolean)
        .map((_) => ({ key: _?.[fieldValue || fieldLabel], text: _?.[fieldLabel] }));
    const selectedObj = dataFormat.find((_) => _.key === selected);
    return (_jsx(Select, { options: dataFormat, label: label, placeholder: placeholder || selected, onChange: (_) => setSelected(_.key), value: selectedObj }));
});
//# sourceMappingURL=WrapperSelect.js.map